<template>
    <div>
	<img class="img-fluid" src="@/assets/imagenes_compartidas/12 boton saltar pregunta.png" alt="">
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
  methods: {
    },
    mounted() {
    },
}
</script>


<style lang="scss" scoped>

</style>